// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"042ab8b0","455":"9dee26b3","488":"78d7d679","977":"fdec4728"}[chunkId] + ".chunk.js";
};